import { render, staticRenderFns } from "./VideoBlock.vue?vue&type=template&id=7a814609&scoped=true&"
import script from "./VideoBlock.vue?vue&type=script&lang=js&"
export * from "./VideoBlock.vue?vue&type=script&lang=js&"
import style0 from "./VideoBlock.vue?vue&type=style&index=0&id=7a814609&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a814609",
  null
  
)

export default component.exports